import { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Sparkles } from "@react-three/drei";
import * as THREE from "three";

function Terrain() {
  const meshRef = useRef();
  const geometry = useMemo(() => new THREE.PlaneGeometry(26, 26, 56, 56), []);
  const base = useMemo(() => geometry.attributes.position.array.slice(), [geometry]);

  useFrame(({ clock, pointer }) => {
    const t = clock.getElapsedTime();
    const pos = geometry.attributes.position;
    for (let i = 0; i < pos.count; i++) {
      const x = base[i * 3];
      const y = base[i * 3 + 1];
      pos.setZ(
        i,
        Math.sin(x * 0.55 + t * 0.35) * Math.cos(y * 0.45 + t * 0.28) * 0.85
      );
    }
    pos.needsUpdate = true;
    if (meshRef.current) {
      meshRef.current.rotation.z += (pointer.x * 0.06 - meshRef.current.rotation.z) * 0.04;
    }
  });

  return (
    <mesh
      ref={meshRef}
      geometry={geometry}
      rotation={[-Math.PI / 2.25, 0, 0]}
      position={[1.5, -2.8, -3]}
    >
      <meshBasicMaterial color="#2A2A2E" wireframe transparent opacity={0.5} />
    </mesh>
  );
}

export default function HeroCanvas() {
  return (
    <div className="absolute inset-0 z-0" aria-hidden="true">
      <Canvas
        camera={{ position: [0, 2.4, 6.5], fov: 55 }}
        dpr={[1, 1.75]}
        gl={{ antialias: true, alpha: true }}
      >
        <Terrain />
        <Sparkles
          count={110}
          scale={[18, 7, 12]}
          size={1.8}
          speed={0.16}
          color="#F5B301"
          opacity={0.55}
          position={[1.5, 0.5, -2]}
        />
        <Sparkles
          count={70}
          scale={[20, 8, 12]}
          size={1.2}
          speed={0.1}
          color="#FFFFFF"
          opacity={0.3}
          position={[0, 1, -4]}
        />
      </Canvas>
    </div>
  );
}
